import { ColDef } from 'ag-grid-community';
import { floatingFilter } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
import { NON_OFFICIAL_FILIERE, NON_OFFICIAL_GRADE } from './constants';

const baseColDef = { ...floatingFilter, sortable: true, resizable: true };

export const getColDefs = (t: TranslationT): ColDef[] => [
    {
        ...baseColDef,
        flex: 1,
        field: NON_OFFICIAL_FILIERE,
        headerName: t(
            'humanResources.settings.gradeMapping.nonOfficialFiliere',
        ),
        sort: 'asc',
    },
    {
        ...baseColDef,
        flex: 2,
        field: NON_OFFICIAL_GRADE,
        headerName: t('humanResources.settings.gradeMapping.nonOfficialGrade'),
        cellRenderer: 'tooltipCellRenderer',
    },
    {
        ...baseColDef,
        flex: 1,
        field: 'officalFiliere',
        headerName: t('humanResources.settings.gradeMapping.officialFiliere'),
        valueGetter: (params) => params.data.officialGrade?.filiere,
    },
    {
        ...baseColDef,
        flex: 1,
        field: 'cadreEmploi',
        headerName: t(
            'humanResources.simulation.freeHypothesis.ifse.cadreEmploi',
        ),
        valueGetter: (params) => params.data.officialGrade?.cadreEmploi ?? '',
    },
    {
        ...baseColDef,
        flex: 2,
        field: 'officalGrade',
        headerName: t('humanResources.settings.gradeMapping.officalGrade'),
        valueGetter: (params) => params.data.officialGrade?.grade,
    },
    {
        field: 'action',
        headerName: t('humanResources.settings.gradeMapping.action'),
        cellRenderer: 'actionsCellRenderer',
        sortable: false,
        flex: 1,
        minWidth: 90,
        // This is a hack, AgGrid doesn't not rerender the cellRenderer data when the value is updated.
        // Only the value is rerendered when updated. Since this cell renderer needs the whole data, we pass it through the value.
        valueGetter: (params) => params.data,
    },
];
